export default "__VITE_ASSET__EwXOtw1n__"